window.addEventListener('load', event => {
    let pinchZoomObjects = document.querySelectorAll('.pinchzoom-me');

    for (let zoom of pinchZoomObjects) {
        let pinchZoomer = new PinchZoom(zoom, {
            draggableUnzoomed: false,
        });
    }
});